import { Component, inject } from '@angular/core';
import { TslSessionService } from 'projects/aztalena-core/src/public-api';

@Component({
  selector: 'app-home-header',
  templateUrl: './home-header.component.html',
  styleUrls: ['./home-header.component.scss'],
  standalone: false
})
export class HomeHeaderComponent {
  private sessionService = inject(TslSessionService);

  get isSignedIn(): boolean {
    return this.sessionService.isSignedIn;
  }
}
